import { createAsyncThunk } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';
import { IPreset } from '../../utils/ModulePresets/preset.interface';
import Preset from '../../utils/ModulePresets/Preset';

interface IActionType {
  payload: IPreset;
  type: string;
}

const initialState: GenericState<Array<IPreset> | null> = { data: null, status: 'loading' };

export const getAllPresets = createAsyncThunk('presets/getAllPresets', async () => {
  const organizationAdminObj = new Preset();
  return await organizationAdminObj.getAllPreset();
});

const presetSlice = createGenericSlice({
  name: 'presets',
  initialState,
  reducers: {
    // On deletion of preset
    deletePreset: (state, action: IActionType) => {
      state.data = state.data
        ? state.data.filter((item) => item.presetName !== action.payload.presetName)
        : state.data;
    },
    // On change in preset
    changePreset: (state, action: IActionType) => {
      state.data = state.data
        ? state.data.map((item) =>
            item.presetName === action.payload.presetName ? action.payload : item
          )
        : state.data;
    },
    // On preset creation
    createPreset: (state, action: IActionType) => {
      state.data = state.data
        ? [...state.data, action.payload].sort((a, b) => a.presetName.localeCompare(b.presetName))
        : state.data;
    },
    // reset to initial state
    resetPresetState: (state) => {
      state = initialState;
    }
  },
  extraReducers: (builder) => {
    // getAllPresets cases
    builder.addCase(getAllPresets.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(getAllPresets.fulfilled, (state, action) => {
      state.status = 'finished';
      state.data = action.payload?.filter((preset) => preset.presetName) ?? [];
    });

    builder.addCase(getAllPresets.rejected, (state, action) => {
      state.status = 'error';
      state.error = 'Something went wrong.';
    });
  }
});

export const { deletePreset, changePreset, createPreset, resetPresetState } = presetSlice.actions;
export default presetSlice.reducer;
